import * as Types from '../../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemoveMemberFromTeamMutationVariables = Types.Exact<{
  data: Types.RemoveMemberFromTeamInput;
}>;


export type RemoveMemberFromTeamMutation = { __typename?: 'Mutation', removeMemberFromTeam: number };


export const RemoveMemberFromTeamDocument = gql`
    mutation RemoveMemberFromTeam($data: RemoveMemberFromTeamInput!) {
  removeMemberFromTeam(data: $data)
}
    `;
export type RemoveMemberFromTeamMutationFn = Apollo.MutationFunction<RemoveMemberFromTeamMutation, RemoveMemberFromTeamMutationVariables>;

/**
 * __useRemoveMemberFromTeamMutation__
 *
 * To run a mutation, you first call `useRemoveMemberFromTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMemberFromTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMemberFromTeamMutation, { data, loading, error }] = useRemoveMemberFromTeamMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveMemberFromTeamMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMemberFromTeamMutation, RemoveMemberFromTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMemberFromTeamMutation, RemoveMemberFromTeamMutationVariables>(RemoveMemberFromTeamDocument, options);
      }
export type RemoveMemberFromTeamMutationHookResult = ReturnType<typeof useRemoveMemberFromTeamMutation>;
export type RemoveMemberFromTeamMutationResult = Apollo.MutationResult<RemoveMemberFromTeamMutation>;
export type RemoveMemberFromTeamMutationOptions = Apollo.BaseMutationOptions<RemoveMemberFromTeamMutation, RemoveMemberFromTeamMutationVariables>;